import { render } from "./psiPayOutProgram.vue?vue&type=template&id=53ff411a"
import script from "./psiPayOutProgram.vue?vue&type=script&lang=jsx"
export * from "./psiPayOutProgram.vue?vue&type=script&lang=jsx"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__